export default {
  notificationList(state) {
    return state.notifications;
  }
};
